import React, { useEffect, useState } from "react";
import Navbar from "../componenst/Navbar";
import Listvoucher from "../componenst/Voucher/Listvoucher";
import Syarat from "../componenst/Voucher/Syarat";

export default function Voucher() {
  const [tanggal, setTanggal] = useState('')


  useEffect(() => {
    const tanggal = new Date().toLocaleDateString();
    setTanggal(tanggal);
  }, [])
  return (
    <div>
      <Navbar judul="Voucher" aicon="true" />
      <div
        className="card shadow"
        style={{ borderRadius: "0px", border: "0px" }}
      >
        <div className="card-body">
          {/* <div className='card mt-5'>
                      <div className='card-body'>
                          <h5>Hello {localStorage.getItem('nama')}</h5>
                          <small>Voucher yang anda dapat, dapat anda tukar melalui admin kami</small>
                      </div>
                 </div> */}

          <img
            src="/img/info.webp"
            className="img-fluid mt-5"
            alt="..."
            style={{ borderRadius: "10px" }}
          ></img>
          <hr />



          {tanggal == '10/1/2026' ?

            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
              <div className="text-center shadow-lg rounded-4 border-0 w-100" style={{ maxWidth: '420px', background: '#fff' }}>
                <div className="p-4" style={{ background: 'linear-gradient(135deg, #0f1677, #4e9dd1)', borderRadius: '16px 16px 0 0' }}>
                  <img src="/img/warning.png" alt="warning" className="img-fluid mb-2" style={{ width: '90px', height: '90px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
                  <h5 className="fw-bold text-white mb-0">Voucher Tidak Aktif</h5>
                </div>
                <div className="p-4">
                  <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
                    <i className="fas fa-exclamation-circle text-danger me-2"></i>
                    Mohon maaf voucher booking lapangan anda sudah tidak bisa digunakan lagi
                  </p>
                </div>
              </div>
            </div>
            :
            <>
              <Syarat />
              <Listvoucher />
            </>}


        </div>
      </div>
    </div>
  );
}
